import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <MediaSection />
        <CarouselSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <FaqSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <IndexSection />
      </main>

      <Footer />
    </div>
  );
}